<template>
  <div>
    <div class="row">
      <div class="col-md-4" >
        <el-dropdown id="selecione-chat">
          <el-select
            v-model="selectedValue"
            placeholder="Selecione o Chat"
          >

            <el-option
              v-for="item in options"
              :id="item.id"
              :key="item.name"
              :label="item.name"
              :value="item.id"
              @click="getDataFilter(value);"
            />
          </el-select>
        </el-dropdown>
      </div>
      <div

        class="col-6 text-right"
        style="margin-left: -159px;"
      >
        <div class="col-md-4">
          <el-dropdown @click.stop id="filter-data-periodo">
            <el-select
              v-model="value"
              placeholder="Selecione"
              size="large"
            >
              <el-option
                v-for="item in optionsData"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
              <div
                class="row"
                style="margin: 0 1px 0px 0px;"
              >
                <div class="col">
                  <el-input
                    id="data_inicial"
                    v-model="endDate"
                    class="ajuste-input-date"
                    maxlength="10"
                    show-word-limit
                    type="date"
                  />
                </div>
                <div
                  class="col align-self-lg-center"
                  style="padding: 0"
                >
                  <span>até</span>
                </div>
                <div class="col">
                  <el-input
                    id="data_final"
                    v-model="startDate"
                    class="ajuste-input-date"
                    maxlength="10"
                    show-word-limit
                    type="date"
                  />
                </div>
                <div
                  class="col"
                  style="padding-left: 0"
                >
                  <el-button
                    :disabled="startDate <= endDate && startDate !== ''"
                    type="primary"
                    @click="getFilterDataIntervalo"
                  >
                    Filtrar
                  </el-button>
                </div>
              </div>

            </el-select>
          </el-dropdown>

        </div>

      </div>
      <div
          id="plano-atual-user"
        class="col-md-2"
        style="margin-right:-706px;margin-left: 121px;"
      >
        <h4
          style="background-color: #ffffff;
    border-radius: 10px;
    border: 1px solid #c9c9c9;
    padding: 6px;text-align: center;
    "
        > {{ dadosPagamento.planocontratado }}</h4>
      </div>
    </div>
    <div class="row match-height mt-4">
      <div class="col-sm-3 col-md-3 v-col-12">
        <b-card
          id="views"
          class="earnings-card hover"
        >
          <b-row class="align-self-center">
            <b-col cols="7">
              <b-card-title class="mb-1">
                Visualizações
              </b-card-title>
              <div class="font-small-8">
                Este mês
              </div>
              <h5 class="mb-1">
                {{ visualizacao }}
              </h5>

              <b-card-text class="text-muted font-small-2" />
            </b-col>
            <b-col
              cols="5"
              class="aling-icon"
            >
              <div
                id="card1"
                class="aling-center-icon-item"
              >
                <i class="el-icon-view" />
              </div>
            </b-col>
          </b-row>

        </b-card>
      </div>
      <div class="col-sm-3 v-col-md-3 v-col-12">
        <b-card
          id="paly"
          class="earnings-card"
        >
          <b-row>
            <b-col cols="7">
              <b-card-title class="mb-1">
                Iniciado
              </b-card-title>
              <div class="font-small-8">
                Este mês
              </div>
              <h5 class="mb-1">
                {{ iniciado }}
              </h5>

            </b-col>
            <b-col
              cols="5"
              class="aling-icon "
            >
              <div
                id="card2"
                class="aling-center-icon-item"
              >
                <i class="el-icon-video-play" />
              </div>
            </b-col>
          </b-row>
        </b-card>
      </div>
      <div class="col-sm-3 v-col-md-3 v-col-12">
        <b-card
          id="PlayRate"
          class="earnings-card"
        >
          <b-row>
            <b-col cols="7">
              <b-card-title class="mb-1">
                Finalizado
              </b-card-title>
              <div class="font-small-8">
                Este mês
              </div>
              <h5 class="mb-1" />
              <h5 class="mb-1">
                {{ finalizado }}
              </h5>
            </b-col>
            <b-col
              cols="5"
              class="aling-icon "
            >
              <div
                id="card3"
                class="aling-center-icon-item"
              >
                <i class="el-icon-s-data" />
              </div>
            </b-col>
          </b-row>
        </b-card>
      </div>
      <div class="col-sm-3 v-col-md-3 v-col-12">
        <b-card
          id="Engajamento"
          class="earnings-card"
        >
          <b-row>
            <b-col cols="7">
              <b-card-title class="mb-1">
                Engajamento
              </b-card-title>
              <div class="font-small-8">
                Este mês
              </div>
              <h5 class="mb-1">
                {{ engajamento }}
              </h5>
            </b-col>
            <b-col
              cols="5"
              class="aling-icon "
            >
              <div
                id="card4"
                class="aling-center-icon-item"
              >
                <i class="el-icon-s-marketing" />
              </div>
            </b-col>

          </b-row>
        </b-card>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 v-col-md-3 v-col-12">
        <FunnelGraph :objs-funnel-geral="objsFunnelGeral" />
      </div>
    </div>

  </div>
</template>
<script>
import { useApi } from '@/composables/useApi'
import FunnelGraph from '@/views/App/Chat/GraficoChat.vue'
import {
  BCardHeader, BCardBody, BCard, BRow, BCol, BCardTitle, BCardText,
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'

const api = useApi()
export default {
  components: {
    BCard,
    BRow,
    BCol,
    BCardTitle,
    BCardText,
    VueApexCharts,
    BCardHeader,
    BCardBody,
    FunnelGraph,
  },
  data() {
    return {
      objsFunnelGeral: [177, 8, 2, 5],
      VUE_APP_HOST_API_BACKEND: process.env.VUE_APP_HOST_API_BACKEND,
      visualizacao: 0,
      engajamento: 0,
      iniciado: 0,
      finalizado: 0,
      options: [],
      dadosPagamento: [],
      selectedValue: '',
      startDate: null,
      endDate: null,
      optionsData: [
        {
          value: 'hoje',
          label: 'Hoje',
        },
        {
          value: 'ontem',
          label: 'Ontem',
        },
        {
          value: 'sete_dias',
          label: 'Últimos 7 dias',
        },
        {
          value: 'trinta_dias',
          label: 'Últimos 30 dias',
        },
        {
          value: 'full_dias',
          label: 'Tempo todo',
        },
      ],
      value: 'sete_dias',
    }
  },

  computed: {

    getUserData() {
      return JSON.parse(localStorage.getItem('userData'))
    },
    formattedDate() {
      return this.$moment(this.apiDate).format('DD MMM')
    },
  },
  watch: {
    value(newValue) {
      if (newValue) {
        this.getDataFilter(newValue)
      }
    },
    selectedValue(newValue) {
      if (newValue) {
        this.getDataFilter(this.value)
      }
    },
  },
  mounted() {
    this.buscarDados()
    this.getChats()
    this.getDataFilter(this.value)
  },
  methods: {
    buscarDados() {
      const options = { method: 'GET' }

      fetch(`${this.VUE_APP_HOST_API_BACKEND}/pagamento/${this.getUserData.id}`, options)
        .then(response => response.json())
        .then(response => {
          this.dadosPagamento = response[0]
        })
        .catch(err => console.error(err))
    },
    async getChats() {
      await api.get(`chat/${this.getUserData.id}`)
        .then(response => {
          this.options = response.data
        })
    },
    getDataFilter(TypeDate) {
      console.log('FUNCAO DATA FILTER', TypeDate)

      if (typeof TypeDate === 'undefined') {
        this.getFilterData7days()
      }
      if (TypeDate === 'hoje') {
        this.getFilterDateHoje()
      }
      if (TypeDate === 'ontem') {
        this.getFilterDataOntem()
      }
      if (TypeDate === 'sete_dias') {
        this.getFilterData7days()
      }
      if (TypeDate === 'trinta_dias') {
        this.getFilterData30days()
      }
      if (TypeDate === 'full_dias') {
        this.getFilterDataTempoTodo()
      }
    },
    async getFilterDateHoje() {
      if (this.selectedValue.length === 0) {
        await api.get(`analytics/today/${this.getUserData.id}`)
          .then(response => {
            this.visualizacao = response.data[0].total_views || 0
            this.iniciado = response.data[0].total_started || 0
            this.finalizado = response.data[0].total_finished || 0
            this.engajamento = `${(response.data[0].total_finished / response.data[0].total_started * 100).toFixed(2)}%` || 0
            this.objsFunnelGeral = [
              response.data[0].total_views || 0,
              response.data[0].total_started || 0,
              response.data[0].total_finished || 0,
              (response.data[0].total_finished / response.data[0].total_started).toFixed(2) || 0,
            ]
          })
      }
      if (this.selectedValue.length > 0) {
        await api.get(`chathoje/${this.selectedValue}`)
          .then(response => {
            this.visualizacao = response.data[0].total_views || 0
            this.iniciado = response.data[0].total_started || 0
            this.finalizado = response.data[0].total_finished || 0
            this.engajamento = `${(response.data[0].total_finished / response.data[0].total_started * 100).toFixed(2)}%` || 0
            this.objsFunnelGeral = [
              response.data[0].total_views || 0,
              response.data[0].total_started || 0,
              response.data[0].total_finished || 0,
              (response.data[0].total_finished / response.data[0].total_started).toFixed(2) || 0,
            ]
          })
      }
    },
    async getFilterDataOntem() {
      if (this.selectedValue.length === 0) {
        await api.get(`analytics/yesterday/${this.getUserData.id}`)
          .then(response => {
            this.visualizacao = response.data[0].total_views || 0
            this.iniciado = response.data[0].total_started || 0
            this.finalizado = response.data[0].total_finished || 0
            this.engajamento = `${(response.data[0].total_finished / response.data[0].total_started * 100).toFixed(2)}%` || 0

            this.objsFunnelGeral = [
              response.data[0].total_views || 0,
              response.data[0].total_started || 0,
              response.data[0].total_finished || 0,
              (response.data[0].total_finished / response.data[0].total_started).toFixed(2) || 0,
            ]
          })
      }
      if (this.selectedValue.length > 0) {
        await api.get(`chatontem/${this.selectedValue}`)
          .then(response => {
            this.visualizacao = response.data[0].total_views || 0
            this.iniciado = response.data[0].total_started || 0
            this.finalizado = response.data[0].total_finished || 0
            this.engajamento = `${(response.data[0].total_finished / response.data[0].total_started * 100).toFixed(2)}%` || 0
            this.objsFunnelGeral = [
              response.data[0].total_views || 0,
              response.data[0].total_started || 0,
              response.data[0].total_finished || 0,
              (response.data[0].total_finished / response.data[0].total_started).toFixed(2) || 0,
            ]
          })
      }
    },
    async getFilterData7days() {
      if (this.selectedValue.length === 0) {
        await api.get(`analytics/lastweek/${this.getUserData.id}`)
          .then(response => {
            this.visualizacao = response.data[0].total_views || 0
            this.iniciado = response.data[0].total_started || 0
            this.finalizado = response.data[0].total_finished || 0
            this.engajamento = `${(response.data[0].total_finished / response.data[0].total_started * 100).toFixed(2)}%` || 0
            this.objsFunnelGeral = [
              response.data[0].total_views || 0,
              response.data[0].total_started || 0,
              response.data[0].total_finished || 0,
              (response.data[0].total_finished / response.data[0].total_started).toFixed(2) || 0,
            ]
          })
      }
      if (this.selectedValue.length > 0) {
        await api.get(`chat7dias/${this.selectedValue}`)
          .then(response => {
            this.visualizacao = response.data[0].total_views || 0
            this.iniciado = response.data[0].total_started || 0
            this.finalizado = response.data[0].total_finished || 0
            this.engajamento = `${(response.data[0].total_finished / response.data[0].total_started * 100).toFixed(2)}%` || 0
            this.objsFunnelGeral = [
              response.data[0].total_views || 0,
              response.data[0].total_started || 0,
              response.data[0].total_finished || 0,
              (response.data[0].total_finished / response.data[0].total_started).toFixed(2) || 0,
            ]
          })
      }
    },
    async getFilterData30days() {
      if (this.selectedValue.length === 0) {
        await api.get(`analytics/lastmonth/${this.getUserData.id}`)
          .then(response => {
            this.visualizacao = response.data[0].total_views || 0
            this.iniciado = response.data[0].total_started || 0
            this.finalizado = response.data[0].total_finished || 0
            this.engajamento = `${(response.data[0].total_finished / response.data[0].total_started * 100).toFixed(2)}%` || 0
            this.objsFunnelGeral = [
              response.data[0].total_views || 0,
              response.data[0].total_started || 0,
              response.data[0].total_finished || 0,
              (response.data[0].total_finished / response.data[0].total_started).toFixed(2) || 0,
            ]
          })
      }
      if (this.selectedValue.length > 0) {
        await api.get(`chatultimomes/${this.selectedValue}`)
          .then(response => {
            this.visualizacao = response.data[0].total_views || 0
            this.iniciado = response.data[0].total_started || 0
            this.finalizado = response.data[0].total_finished || 0
            this.engajamento = `${(response.data[0].total_finished / response.data[0].total_started * 100).toFixed(2)}%` || 0
            this.objsFunnelGeral = [
              response.data[0].total_views || 0,
              response.data[0].total_started || 0,
              response.data[0].total_finished || 0,
              (response.data[0].total_finished / response.data[0].total_started).toFixed(2) || 0,
            ]
          })
      }
    },
    async getFilterDataTempoTodo() {
      if (this.selectedValue.length === 0) {
        await api.get(`analytics/all/${this.getUserData.id}`)
          .then(response => {
            this.visualizacao = response.data[0].total_views || 0
            this.iniciado = response.data[0].total_started || 0
            this.finalizado = response.data[0].total_finished || 0
            this.engajamento = `${(response.data[0].total_finished / response.data[0].total_started * 100).toFixed(2)}%` || 0
            this.objsFunnelGeral = [
              response.data[0].total_views || 0,
              response.data[0].total_started || 0,
              response.data[0].total_finished || 0,
              (response.data[0].total_finished / response.data[0].total_started).toFixed(2) || 0,
            ]
          })
      }
      if (this.selectedValue.length > 0) {
        await api.get(`chatTodos/${this.selectedValue}`)
          .then(response => {
            this.visualizacao = response.data[0].total_views || 0
            this.iniciado = response.data[0].total_started || 0
            this.finalizado = response.data[0].total_finished || 0
            this.engajamento = `${(response.data[0].total_finished / response.data[0].total_started * 100).toFixed(2)}%` || 0
            this.objsFunnelGeral = [
              response.data[0].total_views || 0,
              response.data[0].total_started || 0,
              response.data[0].total_finished || 0,
              (response.data[0].total_finished / response.data[0].total_started).toFixed(2) || 0,
            ]
          })
      }
    },

    async getFilterDataIntervalo() {
      if (this.selectedValue.length === 0) {
        api.get(`get/booster/getViewerDashBoardChat/${this.getUserData.id}?startDate=${this.endDate}&endDate=${this.startDate}`, {})
          .then(response => {
            this.visualizacao = response.data[0].total_views || 0
            this.iniciado = response.data[0].total_started || 0
            this.finalizado = response.data[0].total_finished || 0
            this.engajamento = `${(response.data[0].total_finished / response.data[0].total_started * 100).toFixed(2)}%` || 0
            this.objsFunnelGeral = [
              response.data[0].total_views || 0,
              response.data[0].total_started || 0,
              response.data[0].total_finished || 0,
              (response.data[0].total_finished / response.data[0].total_started).toFixed(2) || 0,
            ]
          })
      }
      if (this.selectedValue.length > 0) {
        api.get(`get/booster/getViewerDashBoardByChat/${this.selectedValue}?startDate=${this.endDate}&endDate=${this.startDate}`, {})
          .then(response => {
            this.visualizacao = response.data[0].total_views || 0
            this.iniciado = response.data[0].total_started || 0
            this.finalizado = response.data[0].total_finished || 0
            this.engajamento = `${(response.data[0].total_finished / response.data[0].total_started * 100).toFixed(2)}%` || 0
            this.objsFunnelGeral = [
              response.data[0].total_views || 0,
              response.data[0].total_started || 0,
              response.data[0].total_finished || 0,
              (response.data[0].total_finished / response.data[0].total_started).toFixed(2) || 0,
            ]
          })
      }
    },
  },
}
</script>
<style>
#views {
  background-color: #18d9ad;
  box-shadow: 0 8px 8px 0 rgba(0, 0, 0, 0.218);
}

#views:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);

}

#paly {
  background-color: #f5a732;
  box-shadow: 0 8px 8px 0 rgba(0, 0, 0, 0.218);
}

#PlayRate {
  background-color: #318feb;
  box-shadow: 0 8px 8px 0 rgba(0, 0, 0, 0.218);
}

#Engajamento {
  background-color: #ee566f;
  box-shadow: 0 8px 8px 0 rgba(0, 0, 0, 0.218);
}

#textView {
  color: #266355;
}

#textPlay {
  color: #986f3a;
}

#textPlayRate {
  color: #2b5485;
}

#textEngajamento {
  color: #983545;
}

#text2 {
  color: #ffffff
}

.aling-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  justify-self: center;
  text-align: center;
  padding-left: 22px;
}

#card1 {
  background: #4db099;
  width: 70px;
  height: 70px;
  border-radius: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
}

#card2 {
  background: #cf974c;
  width: 70px;
  height: 70px;
  border-radius: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
}

#card3 {
  background: #3f7fc9;
  width: 70px;
  height: 70px;
  border-radius: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
}

#card4 {
  background: #cd5065;
  width: 70px;
  height: 70px;
  border-radius: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.aling-icon .aling-center-icon-item i {
  color: white;
  font-size: 30px;
}

.graphic {
  background-color: #393862;
}
</style>
